import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "font-semibold" }
const _hoisted_2 = {
  key: 0,
  viewBox: "0 0 2 2",
  class: "mx-2 inline size-0.5 fill-current",
  "aria-hidden": "true"
}

import type { TitleProps } from "./TitleProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'Title',
  props: {
    text: {},
    textColor: {},
    showDot: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    style: _normalizeStyle({
            color: _ctx.textColor,
        })
  }, [
    _createElementVNode("strong", _hoisted_1, _toDisplayString(_ctx.text), 1),
    (_ctx.showDot)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("circle", {
            cx: "1",
            cy: "1",
            r: "1"
          }, null, -1)
        ])))
      : _createCommentVNode("", true)
  ], 4))
}
}

})